import {SocialPostList, SocialPostRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {SOCIAL_POST_STATUS} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import dayjs from "dayjs";

export const SocialPostListPage = () => {
    const apiManager = useApiManager();

    const preview = (text?: string) => (text && text.length > 120 ? text.slice(0, 120) + "…" : (text ?? "—"));

    const listConfig: AppListConfig<SocialPostList> = {
        title: "Posts sociales",
        onClick: "/app/admin/marketing/social-post",
        headers: [
            {title: "Texto", width: "45%"},
            {title: "Ángulo"},
            {title: "Segmento"},
            {title: "Estado"},
            {title: "Programado"},
        ],
        decorator: (bean: SocialPostList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    <Typography variant="body2" sx={{display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden"}}>
                        {preview(bean.text)}
                    </Typography>
                </TableCell>
                <TableCell>{bean.angle ?? "-"}</TableCell>
                <TableCell>{bean.segment ?? "-"}</TableCell>
                <TableCell>{bean.status ? <SoftChip label={SOCIAL_POST_STATUS[bean.status]?.label ?? bean.status} tone={SOCIAL_POST_STATUS[bean.status]?.tone ?? "neutral"}/> : "—"}</TableCell>
                <TableCell>{bean.scheduledAt ? dayjs(bean.scheduledAt).format("DD/MM/YYYY HH:mm") : "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SocialPostRestControllerApiFactory);
            return ctrl.pageSocialPost(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
